/** Import the ACR headers from the `acr-injection` package dynamically as it uses some timer which will cause e2e or unit tests to timeout */
const importAcrHeaders = () => import('@smg-real-estate/acr-injection');

export async function getAcrHeaders(): Promise<Record<string, string>> {
  const acrInjection = await importAcrHeaders();
  return acrInjection.getAcrHeaders();
}

export function shouldInjectAcrHeaders(): boolean {
  return typeof window !== 'undefined' && import.meta.env.VUE_STAGE === 'prod';
}
